// eslint-disable-next-line import/prefer-default-export
export const getResponseErrorMessage = (e: any) => `${e.message}`;
